import React from 'react';
import { useSelector, } from 'react-redux';

import { MeStateType, ReactChildrenUtil, } from 'common/types';
import { hasAccessSelector, } from 'common/selectors';

type Props = ReactChildrenUtil & {};

const HasAccess: React.FC<Props> = ({ children, }) => {
    const hasAccess = useSelector<MeStateType, boolean>(hasAccessSelector);

    return hasAccess && children;
};

export default HasAccess;
